import './style.scss'

import React from 'react'

import ResetIcon from '~/assets/images/icons/refresh-cw.svg?react'

type ResetSearchButtonProps = {
    className?: string
    onClick: () => void
}

export const ResetSearchButton = ({ className = '', onClick }: ResetSearchButtonProps) => (
    <button
        className={`public-empty-legs__reset-search-button${className ? ` ${className}` : ''}`}
        type="button"
        onClick={onClick}
    >
        <ResetIcon
            className="public-empty-legs__reset-search-button-icon"
            aria-hidden="true"
            focusable="false"
        />
        Reset search
    </button>
)
